export function delayPromise(n: number) {
  return new Promise(r => setTimeout(() => r(n), n))
}
